import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setFieldManagementPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useFieldManagementSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getFieldManagementSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website.field_management_page.field_management_section}`);
      console.log("🚀 ~ getFieldManagementSectionJson ~ data:", response);
      console.log("🚀 ~ getFieldManagementSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setFieldManagementPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Field Management section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getFieldManagementSectionJson();
  }, [getFieldManagementSectionJson]);

  return {
    data,
    loading,
    error,
    getFieldManagementSectionJson,
    fetchOnMount,
    refetch: getFieldManagementSectionJson
  };
};

export default useFieldManagementSection;
